import TopNavigation from './TopNavigation';

const Header = (header) => {
  return (
    <header className="p-2">
      <TopNavigation {...header.topMenu} />
    </header>
  );
};

export default Header;
